/**
 * Human-readable batch labels for dropdowns (pure — no React/API).
 * Course first so identical Batch-1 / Batch 1 names sort and display apart.
 */

function batchName(batch) {
  return (
    batch.batchName ||
    batch.name ||
    (batch.id != null ? `Batch ${batch.id}` : 'Batch')
  );
}

function formatStartDate(value) {
  if (!value) return '';
  const text = String(value);
  const iso = text.match(/^(\d{4}-\d{2}-\d{2})/);
  if (iso) return iso[1];
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '';
  return parsed.toISOString().slice(0, 10);
}

function formatBatchContextParts(batch) {
  return [batch.mode, batch.location, formatStartDate(batch.startDate)]
    .map((part) => String(part || '').trim())
    .filter(Boolean);
}

export function formatBatchOptionDetails(batch) {
  if (!batch) return '';
  const name = batchName(batch);
  const parts = formatBatchContextParts(batch);
  return parts.length ? `${name} (${parts.join(', ')})` : name;
}

export function formatBatchDisplayLabel(batch) {
  if (!batch) return '';
  const details = formatBatchOptionDetails(batch);
  const course = String(batch.course?.courseName || '').trim();
  return course ? `${course} — ${details}` : details;
}

export function batchCourseGroup(batch) {
  return String(batch?.course?.courseName || '').trim() || 'Other courses';
}

/**
 * Shared SearchableSelect getters so Add/Edit User and other pickers stay in sync.
 */
export const BATCH_SEARCHABLE_SELECT_PROPS = {
  getOptionValue: (batch) => (typeof batch === 'object' ? batch.id : batch),
  getOptionLabel: (batch) =>
    typeof batch === 'object' ? formatBatchDisplayLabel(batch) : batch,
  getOptionListLabel: (batch) =>
    typeof batch === 'object' ? formatBatchOptionDetails(batch) : batch,
  getOptionGroup: (batch) => (typeof batch === 'object' ? batchCourseGroup(batch) : ''),
};

export function batchSearchableSelectProps() {
  return BATCH_SEARCHABLE_SELECT_PROPS;
}
